import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, Fish, CalendarDays, ShieldCheck } from "lucide-react";
import { translations } from "./translations";
import PageMeta from "./PageMeta";

export default function AboutPage() {
  const navigate = useNavigate();
  const [lang] = useState("en");
  const t = (key) => translations[lang][key];

  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="About Us | Redruth Sea Angling Association — Sea Fishing Club Cornwall"
        description="Founded in 1962, Redruth Sea Angling Association is Cornwall's leading sea angling club — shore and boat competitions, a thriving junior section, club records, and a welcoming community of anglers. Affiliated to the Angling Trust. Site available in Kernowek (Cornish language)."
        keywords="about RSAA, sea angling club Cornwall, Redruth Sea Angling Association history, Cornish sea fishing club, junior angling Cornwall, Angling Trust affiliated club, Kernowek, Cornish language angling club"
        url="https://www.redruthseaanglingassociation.co.uk/about"
        image="https://www.redruthseaanglingassociation.co.uk/assets/scenic_background.png"
      />
      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center gap-4">
          <button type="button" onClick={() => navigate(-1)}
            className="standalone-only group inline-flex items-center gap-1.5 rounded-full border border-cyan-400/20 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 shadow-lg shadow-black/20 backdrop-blur transition hover:-translate-x-0.5 hover:border-cyan-300/40 hover:bg-cyan-400/10 hover:text-white">
            ← Back
          </button>
          <div>
            <h1 className="heading-glow text-2xl font-bold text-white sm:text-3xl">About RSAA</h1>
          </div>
        </div>

        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">{t("aboutLabel")}</p>
        <h2 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">{t("aboutHeading")}</h2>

        <div className="mt-10 space-y-6">
          {[
            { icon: Users,        heading: t("card1Heading"), paras: [t("card1Para1"), t("card1Para2")] },
            { icon: Fish,         heading: t("card2Heading"), paras: [t("card2Para1"), t("card2Para2"), t("card2Para3")] },
            { icon: CalendarDays, heading: t("card3Heading"), paras: [t("card3Para1"), t("card3Para2")] },
            { icon: ShieldCheck,  heading: t("card4Heading"), paras: [t("card4Para1"), t("card4Para2")] },
          ].map(({ icon: Icon, heading, paras }) => (
            <div key={heading} className="rounded-[2rem] border border-white/10 bg-gradient-to-br from-white/5 to-white/[0.02] p-8 sm:p-10 panel-lift">
              <div className="flex items-center gap-4">
                <div className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-400/10 to-cyan-400/5 border border-cyan-300/20">
                  <Icon className="h-6 w-6 text-cyan-300" />
                </div>
                <h3 className="text-xl font-bold text-white sm:text-2xl">{heading}</h3>
              </div>
              <div className="mt-5 space-y-3">
                {paras.map((p, i) => (
                  <p key={i} className="text-base leading-8 text-slate-300">{p}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
